import React, {Component} from 'react';
import './App.css';

import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import {withSnackbar} from 'notistack';
import axios from 'axios';

import ModalPopup from './ModalPopup';
import ModalPopupMicrodrama from './ModalPopupMicrodrama';
import GetAppIcon from "@material-ui/icons/GetApp"

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {microdramaFileUploadUrl, urlConfig} from "./config";

const styles = theme => ({
    container: {
        position: 'relative',
    },
});

class MicroDramaIngestion extends Component {

    constructor(props) {
        super(props);

        this.state = {
            file: null, fileName: '', isloading: false, show: false, message: '',isError: false
        };
    }

    handleFileChange = (event) => {

        const file = event.target.files[0];

        this.validateCsvFile(file);
    };

    validateCsvFile = (file) => {

        if (!file) {
            return;
        }

        if (file.size === 0) {
            this.setState({
                file: null,
                fileName: '',
                isError: true,
                message: 'Uploaded CSV file is empty.'
            });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {

            const csvContent = e.target.result;

            const lines = csvContent
                .split(/\r?\n/)
                .filter(line => line.trim() !== '');

            if (lines.length === 0) {
                this.setState({
                    file: null,
                    fileName: '',
                    message: 'Uploaded CSV file is empty.'
                });
                return;
            }

            const headers = lines[0]
                .split(',')
                .map(header =>
                    header.trim().replace(/^"|"$/g, '')
                );

            const requiredHeaders = [
                'CCS Series Name',
                'EP Number',
                'EP CCS Product ID',
                'DRM'
            ];

            const missingHeaders = requiredHeaders.filter(
                header => !headers.includes(header)
            );

            if (missingHeaders.length > 0) {
                this.setState({
                    file: null,
                    fileName: '',
                    isError: true,
                    message:
                        `Missing required column(s): ${missingHeaders.join(', ')}`
                });
                return;
            }

            if (lines.length <= 1) {
                this.setState({
                    file: null,
                    fileName: '',
                    isError: true,
                    message:
                        'CSV must contain at least one data row besides the header.'
                });
                return;
            }

            const validationErrors = [];

            for (let i = 1; i < lines.length; i++) {

                const columns = lines[i]
                    .split(',')
                    .map(col =>
                        col.trim().replace(/^"|"$/g, '')
                    );

                const ccsSeriesName = columns[headers.indexOf('CCS Series Name')];
                const epNumber = columns[headers.indexOf('EP Number')];
                const productId = columns[headers.indexOf('EP CCS Product ID')];
                const drm = columns[headers.indexOf('DRM')];

                const isInvalid = (value) =>
                    !value ||
                    value.trim() === '' ||
                    value.toLowerCase() === 'null';

                if (isInvalid(ccsSeriesName)) {
                    this.setState({
                        file: null,
                        fileName: '',
                        isError: true,
                        message: `Row ${i + 1}: CCS Series Name is mandatory and cannot be empty or null.`
                    });
                    return;
                }

                if (isInvalid(epNumber)) {
                    this.setState({
                        file: null,
                        fileName: '',
                        isError: true,
                        message: `Row ${i + 1}: EP Number is mandatory and cannot be empty or null.`
                    });
                    return;
                }

                if (isInvalid(productId)) {
                    this.setState({
                        file: null,
                        fileName: '',
                        isError: true,
                        message: `Row ${i + 1}: EP CCS Product ID is mandatory and cannot be empty or null.`
                    });
                    return;
                }

                if (isInvalid(drm)) {
                    this.setState({
                        file: null,
                        fileName: '',
                        isError: true,
                        message: `Row ${i + 1}: DRM is mandatory and cannot be empty or null.`
                    });
                    return;
                }
            }

            if (validationErrors.length > 0) {

                this.setState({
                    file: null,
                    fileName: '',
                    isError: true,
                    message: validationErrors.join('\n')
                });

                return;
            }

            this.setState({
                file,
                fileName: file.name,
                isError: false,
                message: ''
            });
        };

        reader.readAsText(file);
    };

    downloadSampleCSV = () => {

        axios({
            url: `${urlConfig.cmsURL}/microdrama/template/download/description`,
            method: 'GET',
            responseType: 'blob'
        }).then((response) => {

            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );

            const link = document.createElement('a');
            link.href = url;
            link.download = 'microdrama_sample.csv';

            document.body.appendChild(link);
            link.click();
            link.remove();
        });
    };

    microDramaUpload = (event) => {

        event.preventDefault();

        const {file} = this.state;

        if (!file) {
            return;
        }

        this.setState({
            isloading: true, message: ''
        });

        const formData = new FormData();

        formData.append('file', file);

        axios.post(urlConfig.microdramaFileUploadUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {

                console.log(response.data);

                this.setState({
                    isloading: false,
                    file: null,
                    fileName: '',
                    show: false,
                    isError: false,
                    message:
                        'Your request has been submitted successfully. Please check after some time.'
                });

            })
            .catch((error) => {

                console.error(error);

                this.setState({
                    isloading: false,
                    show: false,
                    isError: true,
                    message:
                        'Failed to submit MicroDrama ingestion request.'
                });

            })
    };

    render() {

        const {classes} = this.props;

        const {
            fileName, isloading, show, message, isError
        } = this.state;

        const onClickPopupClose = () => this.setState({
            show: false
        });

        const onClickPopupOpen = (e) => {

            e.preventDefault();

            if (!this.state.file) {
                this.setState({
                    isError: true,
                    message: 'Please upload a valid CSV file.'
                });
                return;
            }

            this.setState({
                show: true
            });
        };

        return (

            <React.Fragment>

                <Paper>

                    <Grid
                        container
                        justify="center"
                        alignItems="center"
                        style={{ marginBottom: '20px' }}
                    >

                        <Grid item xs={5}>
                            <Button
                                variant="outlined"
                                onClick={this.downloadSampleCSV}
                            >
                                <GetAppIcon />
                                Download Sample CSV File
                            </Button>
                        </Grid>

                    </Grid>

                    <Grid
                        container
                        spacing={0}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                    >

                        <Grid item xs={1}></Grid>

                        <Grid item xs={10}>

                            <form onSubmit={onClickPopupOpen}>

                                <FormGroup row>

                                    <Grid
                                        container
                                        spacing={2}
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="center"
                                    >

                                        <Grid item xs={8}>

                                            <label>
                                                <strong>
                                                    Upload MicroDrama CSV
                                                </strong>
                                            </label>

                                            <br/>

                                            <input
                                                type="file"
                                                accept=".csv"
                                                onChange={this.handleFileChange}
                                            />


                                        </Grid>

                                        <Grid item xs={2}>

                                            <Button
                                                disabled={isloading || !this.state.file}
                                                variant="contained"
                                                color="primary"
                                                type="submit"
                                                size="large"
                                                className={classes.button}
                                            >
                                                {isloading ? 'Uploading...' : 'Submit'}
                                            </Button>

                                        </Grid>

                                        {show && (<ModalPopupMicrodrama
                                                show={show}
                                                close={onClickPopupClose}
                                                submit={this.microDramaUpload}
                                            />)}

                                    </Grid>

                                </FormGroup>

                            </form>

                            <ModalPopup/>

                            <style jsx>{`
                                .message {
                                    margin-top: 20px;
                                    font-size: 1rem;
                                    font-weight: 500;
                                    text-align: center;
                                }
                            `}</style>

                            {message && (<p
                                    className="message"
                                    style={{
                                        color: isError ? '#dc3545' : '#006400',
                                        whiteSpace: 'pre-line'
                                    }}
                                >
                                    {message}
                                </p>)}

                            <br/>

                        </Grid>

                    </Grid>

                </Paper>

            </React.Fragment>);
    }
}

MicroDramaIngestion.propTypes = {
    classes: PropTypes.object.isRequired, theme: PropTypes.object.isRequired,
};

export default withSnackbar(withStyles(styles, {withTheme: true})(MicroDramaIngestion));